module.exports = __webpack_public_path__ + "img/sc-bg-border.2f7a6df7.png";